import React from "react"
import cookie from "react-cookies"
import { connect } from "react-redux"
import queryString from "query-string"

import { initApp } from "../../actions/appInitAct"

import { ThemeMode } from "../common/common"
import Cover from "./cover"


class IframeSearching extends React.Component {
    constructor() {
			super();
			this.state = {
				appInit: "",
				iframe: true,
				theme: ThemeMode.LIGHT
			}
			this.trackToGAAtFindCar = this.trackToGAAtFindCar.bind(this)
    }

	componentDidMount() {
		window.scrollTo(0, 0);
		
		this.initApp();
			//overide filter by query params
		if (this.props.location && this.props.location.search) {
				
				const query = queryString.parse(this.props.location.search);
				let theme; 
				if (query.theme) {
					theme = query.theme
				}

				this.setState({
					theme
				})

				//GA tracking
				if (query.utm_source) {
					cookie.save("_utm_src", query.utm_source, { path: '/' });
					cookie.save("_utm_src", query.utm_source, { path: '/', domain: '.mioto.vn' });
				}
				if (query.utm_campaign) {
					cookie.save("_utm_campaign", query.utm_campaign, { path: '/' });
					cookie.save("_utm_campaign", query.utm_campaign, { path: '/', domain: '.mioto.vn' });
				}
				if (query.utm_medium) {
					cookie.save("_utm_medium", query.utm_medium, { path: '/' });
					cookie.save("_utm_medium", query.utm_medium, { path: '/', domain: '.mioto.vn' });
				}
				if (query.utm_term) {
					cookie.save("_utm_term", query.utm_term, { path: '/' });
					cookie.save("_utm_term", query.utm_term, { path: '/', domain: '.mioto.vn' });
				}
				if (query.utm_ext) {
					cookie.save("_utm_ext", query.utm_ext, { path: '/' });
					cookie.save("_utm_ext", query.utm_ext, { path: '/', domain: '.mioto.vn' });
				} else {
					cookie.remove("_utm_ext", { path: '/' });
					cookie.remove("_utm_ext", { path: '/', domain: '.mioto.vn' });
				}
			}

	}

	initApp() {
		this.props.dispatch(initApp());
	}

	trackToGAAtFindCar() {
		
		const utmSrc = cookie.load("_utm_src") || "web_directly";
		const utmExt = cookie.load("_utm_ext") || "no_label";

		// window.ga('send', 'event', utmSrc, "CAR_FINDING_INTEGRATE", utmExt);
		window.gtag('event', "CAR_FINDING_INTEGRATE", {
			event_category: utmSrc,
			event_label: utmExt,
			campaign: {source: utmSrc}
		});
	}
	

	render() {
		
		const { iframe, theme } = this.state;

		return (
				<div className="mioto-layout">
					<Cover iframe={iframe} theme={theme} trackToGAAtFindCar={this.trackToGAAtFindCar}/>
				</div>
		)
	}
}

function mapSate(state) {
	return {
			appInit: state.appInit
	}
}

IframeSearching = connect(mapSate)(IframeSearching);

export default IframeSearching;